import ENVIRONMENT from '@/environments/environment';

import { EcommercePlatform, EcommerceWidget } from '../../interfaces/PluginInterface/PluginInterface';
import Api from '../../utils/apiHelper';
import { allResponse } from '../operation/operationsInterface';

const EcommerceWidgetAPI = {
  getPlatform: async (): Promise<allResponse<EcommercePlatform>> => {
    const URL = ENVIRONMENT.URL_API_ECOMMERCE + ENVIRONMENT.URL_API_ECOMMERCE_APIS.PLATFORM;
    const response = await Api.GET(URL);
    return response;
  },
  getWidget: async (): Promise<allResponse<EcommerceWidget>> => {
    const URL = ENVIRONMENT.URL_API_ECOMMERCE + ENVIRONMENT.URL_API_ECOMMERCE_APIS.WIDGET;
    const response = await Api.GET(URL);
    return response;
  },
  updatePlatform: async (data: any): Promise<allResponse<EcommercePlatform>> => {
    const URL = ENVIRONMENT.URL_API_ECOMMERCE + ENVIRONMENT.URL_API_ECOMMERCE_APIS.PLATFORM;
    const response = await Api.PUT(URL, data);
    return response;
  },
  updateWidget: async (data: any): Promise<EcommerceWidget> => {
    const URL = ENVIRONMENT.URL_API_ECOMMERCE + ENVIRONMENT.URL_API_ECOMMERCE_APIS.WIDGET;
    const response = await Api.PUT(URL, data);
    return response;
  },
  postWidget: async (data: any): Promise<allResponse<EcommerceWidget>> => {
    const URL = ENVIRONMENT.URL_API_ECOMMERCE + ENVIRONMENT.URL_API_ECOMMERCE_APIS.WIDGET;
    const response = await Api.POST(URL, data);
    return response;
  },
};

export const {
  getPlatform, getWidget, updatePlatform, updateWidget, postWidget
} = EcommerceWidgetAPI;
